export default function getResource(label, vars = []) {
    const resources = {
        promotionalTexts: 'Textos promotionnels',
        description: 'Inscrivez-vous aux alertes par texto de Sephora et profitez des nouveautés, des événements et d’offres exclusives.',
        status: 'Statut:',
        subscribed: 'Inscrit',
        notSubscribed: 'Non inscrit',
        subscribe: 'S’abonner',
        edit: 'Modifier',
        confirmationPrefix: 'Nous avons envoyé une confirmation au ',
        confirmationSuffix: '. Répondez O pour vous abonner. Vous ne l’avez pas reçu?',
        resend: 'Envoyez le courriel à nouveau',
        unsubscribe: 'Unsubscribe'
    };
    return resources[label];
}
